import { defineMessages } from 'utils/intl';

export default defineMessages({
  availability: 'Dostępność',
  availabilityProduct: 'Dostępność produktu',
  askForAvailability: 'Zapytaj o dostępność',
  pcs: '{quantity} szt.',
  soon: 'W dostawie',
  productIsArriving: 'Oczekujemy na dostawę',
  availableSoon: 'Dostępny wkrótce',
  prereleaseProduct: 'Produkt przedpremierowy',
  from: 'od {date}',
  in: 'za {days} dni',
});
